import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-gray-300 py-10 border-t-4 border-yellow-400">
      <div className="max-w-screen-xl px-4 mx-auto sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6">
        
        {/* Branding & Copyright */}
        <div className="text-center md:text-left">
          <p className="text-xl font-extrabold text-white mb-1">
            Nigeria Police Force
          </p>
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} NPF Stolen Vehicle Portal. All Rights Reserved.
          </p>
        </div>
        
        {/* Navigation Links */}
        <ul className="flex flex-wrap justify-center gap-6 text-sm font-medium">
          <li>
            <Link to="/about" className="hover:text-yellow-400 transition-colors">
              About
            </Link>
          </li>
          <li>
            <a href="#" className="hover:text-yellow-400 transition-colors">
              Privacy Policy
            </a>
          </li>
          <li>
            <a href="#" className="hover:text-yellow-400 transition-colors">
              Licensing
            </a>
          </li>
          <li>
            <a href="#" className="hover:text-yellow-400 transition-colors">
              Contact
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );}